import { render, staticRenderFns } from "./ConfirmGeneral.vue?vue&type=template&id=8d80bfbc&scoped=true"
import script from "./ConfirmGeneral.vue?vue&type=script&lang=js"
export * from "./ConfirmGeneral.vue?vue&type=script&lang=js"
import style0 from "./ConfirmGeneral.vue?vue&type=style&index=0&id=8d80bfbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d80bfbc",
  null
  
)

export default component.exports